// extracted by mini-css-extract-plugin
module.exports = {"container":"fullPageMessage_container__2-rQo","messageContainer":"fullPageMessage_messageContainer__Ef4qZ"};